/**
 * Ko plugin to registerTrackableObservable
 */
define('customPlugins/registerTrackableObservable',['knockout', 'lodash', 'jquery', 'plugins/router', 'durandal/app', 'atn/atn', 'common/utils'],
    function(ko, _, $, router, app, atn, commonUtils) {
        'use strict';

        var choiceSave = 'Save',
            choiceLeave = 'Leave',
            choiceCancel = 'Cancel',
            choiceOk = 'Ok',
            message = 'Unsaved changes will be lost if you leave this screen.<br /> Choose <strong>Save</strong>' +
                ' to update with changes and leave.<br /> OR Choose <strong>Leave</strong> without saving changes.',
            trackableMismatchFailure = 'There was an error saving the form.Please contact support.',
            title ='Unsaved Changes',
            trackableObsList = [],
            currentDomain = window.location.href.split('#')[1],
            currentUrl = ko.observable(),
            //  to allow unclean exit from application even if there is some trackable observable remaining
            allowUncleanExit = ko.observable(false);

        /**
         * computed properted  added to app that gives current url
         * @type {string}
         */
        app.currentUrl = ko.computed({
            read: function() {
                return currentUrl();
            },
            deferEvaluation: true
        });

        ko.bindingHandlers.navigateUrl = {
            init: function(element, valueAccessor) {
                $(element).on('click', function() {
                    _.defer(function() {
                        var value = valueAccessor(),
                            url = ko.utils.unwrapObservable(value);

                        // if url is empty then need not navigate anywhere.
                        if (url) {
                            currentUrl(url);
                            navigate(currentUrl());
                        }
                    });
                });
            }
        };

        window.onbeforeunload = function() {
            if (getFirstDirtyObserable() && !allowUncleanExit()) {
                return atn.config.messages.unsavedChanges.windowUnloadMessage;
            }
        };

        //  reset any unsaved changes in case of hashchange
        window.addEventListener('hashchange',
            /**
             * to reset any unsaved changes
             * @return {undefined}
             */
            function() {
                var dirtyObs = getFirstDirtyObserable();
                if (dirtyObs) {
                    dirtyObs.reset();
                    //  rechecking dirty observable and throwing exception
                    //  in case observable remain dirty
                    checkDirtyObservable();
                }
            });

        atn.isLoggedOut.subscribe(changeAllowUncleanExit);

        return {
            addTrackableObs: addTrackableObs,
            navigate: navigate,
            checkUncleanTrackable: checkUncleanTrackable,
            allowUncleanExit: allowUncleanExit
        };

        function addTrackableObs(trackableObs) {
            trackableObsList.push(trackableObs);
        }

        /**
         * function to check any modified(dirty) trackable observables and navigate/stay on same page based on user input.
         * @param  {Object} url   the url to naivgate to based on user input/state of the trackables.
         * @return {undefined}
         */
        function navigate(url) {
            var promise = checkUncleanTrackable();
            promise.done(function(isDirty) {
                if (isDirty) {
                    _.defer(navigate, url);
                } else {
                    var urlParts = url.split('#');
                    if (!urlParts[0] || currentDomain === urlParts[0]) {
                        router.navigate(urlParts[1]);
                    } else {
                        window.location.href = url;
                    }
                }
            });
        }

        /**
         * This function checks for dirty observable and generates a popup with save, leave and cancel
         * If save is clicked then form is saved with the changes
         * If Leave is clicked then form will be reset with original values and will be redirected to the user requested page.
         * If cancel is clicked then form will remain in the same place.
         * @return promise
         */
        function checkUncleanTrackable() {
            var dirtyObs = getFirstDirtyObserable();
            var deferred = $.Deferred();
            if (dirtyObs) {
                var promise = app.atnCustomDialog(
                    message, title, [choiceSave, choiceLeave, choiceCancel], 0
                );
                promise.done(function(val) {
                    if (val === choiceSave) {
                        //  attempt to save the validator
                        var savePromise = dirtyObs.save();
                        //  check if observable doesn't have isValid property or observable is valid
                        if (!_.isFunction(dirtyObs.isValid) || dirtyObs.isValid()) {
                            //  in case observable has no validation errors, navigate
                            if (_.isFunction(savePromise.done)) {
                                savePromise.done(function() {
                                    //re-checking dirty observable
                                    var checkDirtyObsPromise = checkDirtyObservable();
                                    checkDirtyObsPromise.fail(function() {
                                        deferred.resolve();
                                    });
                                });
                            } else {
                                deferred.resolve();
                            }
                        }
                    } else if (val === choiceLeave) {
                        if (dirtyObs.leave) {
                            dirtyObs.leave();
                        }
                        dirtyObs.reset();
                        //rechecking dirty observable
                        var checkDirtyObsPromise = checkDirtyObservable();
                        checkDirtyObsPromise.fail(function() {
                            deferred.resolve(true);
                        });
                    } else {
                        deferred.reject();
                    }
                });
            } else {
                //resolve with true if any observable was not found dirty.
                deferred.resolve(false);
            }
            return deferred.promise();
        }

        /**
         * This function re-checks the dirty observable and if form is dirty generates a popup.
         * @return promise.
         */
        function checkDirtyObservable() {
            var deferred = $.Deferred();
            var dirtyObs = getFirstDirtyObserable();
            if (dirtyObs) {
                var popupPromise = app.atnCustomDialog(
                    trackableMismatchFailure, title, [choiceOk], 0
                );
                popupPromise.done(function() {
                    allowUncleanExit(true);
                    window.location.href = commonUtils.createURL(window.location.href);
                });
            } else {
                deferred.reject();
            }
            return deferred.promise();
        }

        function getFirstDirtyObserable() {
            return _.find(trackableObsList, function(obs) {
                return _.isFunction(obs.isPristine) && !obs.isPristine();
            });
        }

        function changeAllowUncleanExit(isLoggedOut) {
            allowUncleanExit(!isLoggedOut);
        }

    });

